import React from "react";
import Modal from "react-modal";
import { IoClose } from "react-icons/io5";
import merge from "lodash.merge";

Modal.setAppElement("#root"); // Specify the root element for accessibility

const defaultStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    borderRadius: "14px",
    border: "transparent",
    boxShadow: "0px 4px 8px 0px #0000001C",
    maxWidth: "908px",
    width: "100%",
    position: "fixed",
    height: "auto",
    overflowY: "auto",
  },
};

const CustomModal = ({ isOpen, onClose, title, children, style = {} }) => {
  if (!isOpen) return null;

  // Merge default styles with user-provided styles
  const mergedStyles = merge({}, defaultStyles, style);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={title}
      style={mergedStyles} // Pass the merged style here
    >
      <div className="py-3 relative">
        <h2 className="text-gray_900 text-base font-semibold font-pop">
          {title}
        </h2>
        <button
          onClick={onClose}
          className={`absolute right-0 ${title !== " " ? "top-3" : "top-0"}`}
        >
          <IoClose className="text-2xl text-gray_900" />
        </button>
      </div>
      <div>{children}</div>
    </Modal>
  );
};

export default CustomModal;
